import { render } from "./SidebarMenu.vue?vue&type=template&id=96216fa2&scoped=true"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"

import "./SidebarMenu.vue?vue&type=style&index=0&id=96216fa2&scoped=true&lang=scss"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96216fa2"]])

export default __exports__